import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DashboardComponent } from './dashboard.component';
import { SharedModule } from '../../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { DashboardSandbox } from '../../../../core/dashboard/dashboard.sandbox';
import { DashboardService } from '../../../../core/dashboard/dashboard.service';
import { EffectsModule } from '@ngrx/effects';
import { DashboardEffect } from '../../../../core/dashboard/effects/dashboard.effect';
import { OrderSandbox } from '../../../../core/order/order.sandbox';
import { OrderService } from '../../../../core/order/order.service';
import { OrderEffect } from '../../../../core/order/order-effects/order.effects';
import { PaymentService } from '../../../../core/payment/payment.service';
import { PaymentSandbox } from '../../../../core/payment/payment.sandbox';
import { PaymentEffect } from '../../../../core/payment/payment-effects/payment.effects';
import { ChartsModule } from 'ng2-charts';
import { CommonSandbox } from '../../../../core/common/common.sandbox';
import { SocialLoginModule, SocialAuthServiceConfig } from 'angularx-social-login';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {
  GoogleLoginProvider,
  FacebookLoginProvider
} from 'angularx-social-login';
import { CustomerService } from '../../../../core/customers/customer.service';
import { FormsModule } from '@angular/forms';


export const routes = [
  {
    path: '',
    component: DashboardComponent,
    data: {
      title: 'Dashboard',
    }
  }
];
@NgModule({
  declarations: [DashboardComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    ChartsModule,
    FormsModule,
    NgbModule,
    EffectsModule.forFeature([DashboardEffect, OrderEffect, PaymentEffect]),
    SocialLoginModule
  ],
  providers: [DashboardSandbox, DashboardService, CustomerService, OrderSandbox, OrderService, PaymentSandbox, CurrencyPipe, PaymentService, CommonSandbox, {
    provide: 'SocialAuthServiceConfig',
    useValue: {
      autoLogin: false,
      providers: [
        {
          id: GoogleLoginProvider.PROVIDER_ID,
          provider: new GoogleLoginProvider(
            '112227150749-h238i8gf0eqauetkccqtb3r5r7hf00d9.apps.googleusercontent.com'
          )
        },
        {
          id: FacebookLoginProvider.PROVIDER_ID,
          provider: new FacebookLoginProvider('clientId')
        }
      ],
      onError: (err) => {
        console.error(err);
      }
    } as SocialAuthServiceConfig,
  }]
})
export class DashboardModule { }
